<template>
  <div class="ll-text-button-list">
    <WsTextButton001
      v-for="(template_e,template_k) in buttonList"
      :key="template_k"
      :leading-icon="template_e.icon"
      :leadingImage="template_e.img"
      white
      @click="$_buttonClick(template_e)"
    >
      {{ $t(template_e.name) }}
    </WsTextButton001>
  </div>
</template>
<script>
export default {
  name: "LlTextButtonList",
  props: {
    buttonList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    $_buttonClick(button) {
      this.$emit("click", button);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-text-button-list";
</style>